import apiClient from './apiClient.js';

export const deleteGathering = async (gathering_id) => {
    const session_url = '/gathering';

    try {
        const response = await apiClient.delete(session_url, {
            data: {
                gathering_id: gathering_id,
            },
        });
        return response.data.response;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
